export default __webpack_public_path__ + "static/media/Commander's Belt of Dynastic Rule.39b4a536.jpg";